// Avisos comerciais do teste gratuito (antifraude de trial). Nunca explicam sinais ou mecanismos de detecção.
export default {
  consumed: {
    title: 'Teste gratuito já utilizado',
    message: 'O teste gratuito deste recurso já foi utilizado.<br><br>Deseja continuar com a contratação?',
    informative: 'O teste gratuito deste recurso já foi utilizado.',
  },
  restrictedEvaluation: {
    title: 'Avaliação com recursos limitados',
    message: 'Podemos disponibilizar um período de avaliação com algumas funcionalidades desabilitadas.<br><br>Você poderá utilizar os demais recursos disponíveis normalmente.<br><br>Deseja continuar?',
  },
  moduleUnavailable: {
    title: 'Recurso indisponível nesta avaliação',
    message: 'Este recurso não está disponível na modalidade atual do seu teste gratuito.<br><br>Deseja continuar com a contratação?',
    informative: 'Este recurso não está disponível na modalidade atual do seu teste gratuito.',
  },
  byokRequired: {
    title: 'Credenciais próprias necessárias',
    message: 'Configure suas próprias credenciais para usar este módulo durante esta avaliação.',
    informative: 'Este módulo exige credenciais próprias durante esta avaliação.',
  },
};
